
import { useSelector } from "react-redux";
import { get } from "lodash";

import {
    REQUEST_MASTER_PROMOCODE,
    REQUEST_CREATE_MASTER_PROMOCODE,
    REQUEST_UPDATE_MASTER_PROMOCODE,
    SET_MASTER_PROMOCODE,
    SUCCESS_CREATE_MASTER_PROMOCODE,
    SUCCESS_UPDATE_MASTER_PROMOCODE,
    ERROR_GET_MASTER_PROMOCODE,
    ERROR_CREATE_MASTER_PROMOCODE,
    ERROR_UPDATE_MASTER_PROMOCODE,
    SET_MESSAGE_MASTER_PROMOCODE,
} from "./promoCodeActionTypes"
import { IPromoCode } from "../../types/promocde";
// import { REQUEST_MASTER_PROMOCODE } from "./promoCodeActionTypes";

interface IState {
    busy: boolean;
    message: string;
    masterPromoCode: IPromoCode[];
}

const initialState: IState =
{
    busy: false,
    message: "",
    masterPromoCode: [],
};

const promocode = (state = initialState, action: Record<string, any>) => {
    switch (action.type) {
        case REQUEST_MASTER_PROMOCODE:
        case REQUEST_CREATE_MASTER_PROMOCODE:
        case REQUEST_UPDATE_MASTER_PROMOCODE:
            return {
                ...state,
                busy: true,
                message: "",
            };

        case SET_MESSAGE_MASTER_PROMOCODE:
            return {
                ...state,
                message: "",
            };

        case SET_MASTER_PROMOCODE:
            return {
                ...state,
                busy: false,
                message: "",
                masterPromoCode: action.payload,
            };

        case SUCCESS_CREATE_MASTER_PROMOCODE:
            return {
                ...state,
                busy: false,
                message: "",
                masterPromoCode: [...state.masterPromoCode, action.payload],
            };

        case SUCCESS_UPDATE_MASTER_PROMOCODE:
            return {
                ...state,
                busy: false,
                message: "",
                masterPromoCode: state.masterPromoCode.map((mp) => {
                    return get(mp, "_id") === action.payload._id ? action.payload : mp;
                }),
            };

        case ERROR_GET_MASTER_PROMOCODE:
        case ERROR_CREATE_MASTER_PROMOCODE:
        case ERROR_UPDATE_MASTER_PROMOCODE:
            return {
                ...state,
                busy: false,
                message:
                    action.payload || "Something happened wrong try again after sometime",
            };
        default:
            return state;
    }
}

export default promocode;


export function usePromoCodeMaster() {
    return useSelector((state: Record<string, any>) => state.promocode);
}
